import { render, staticRenderFns } from "./CdpDetail.vue?vue&type=template&id=31e8f747&"
import script from "./CdpDetail.vue?vue&type=script&lang=ts&"
export * from "./CdpDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports